<template>
  <custom-modal
    @close="toggleModal"
    :modalActive="modalActive"
    :class-name="'g-popup-new join-news-letter'"
  >
    <div class="content">
      <div class="g-popup-col">
        <div class="d-flex">
          <div class="g-popup-img">
            <!-- <img src="https://endpoint.cultureinyourcity.com/uploads/vYWIecc_qh-svxe3GFdqb.png" alt="img"> -->
          </div>
          <div
            class="g-popup-content p-5 d-flex flex-column justify-content-center"
          >
            <div class="page-title">
              <h2 class="d-hex-color fw-semibold mb-3">Join Our Newsletter</h2>
              <p class="d-hex-color mt-2">
                Subscribe to receive the latest news and promotions directly to
                your inbox.
              </p>
            </div>
            <div class="popup-form">
              <div class="g-form-col">
                <form
                  class="mt-2 pt-1"
                  data-gtm-form-interact-id="2"
                  method="POST"
                  @submit.prevent="submitNewsLetterForm"
                >
                  <span
                    v-if="errorMessage"
                    class="text-center mt-3 text-danger"
                    >{{ errorMessage }}</span
                  >
                  <span class="mt-4 input-f g-input undefined" required="true">
                    <span class="position-relative">
                      <base-input
                        v-model="formFields.email"
                        value=""
                        type="email"
                        placeholder="Enter email address"
                        is-required
                        is-borderless
                        custom-classes="text-lg text-primary__color mb-1 block d-flex"
                        label="Email Address"
                        @input="emailErrorMessage = ''"
                      />
                      <p v-if="emailErrorMessage" class="nl-error">{{ emailErrorMessage }}</p>
                    </span>
                  </span>
                  <span class="mt-4 input-f g-input undefined" required="true">
                    <span class="position-relative">
                      <label
                        class="text-lg text-primary__color mb-1 block d-flex"
                      >
                        Please select your focus area(s).</label
                      >
                      <div class="nl-options mt-3">
                        <label
                          class="nl-option"
                          :class="{ 'nl-option--selected': formFields.userTypes.includes('Seeker') }"
                        >
                          <input
                            type="checkbox"
                            name="userType"
                            v-model="formFields.userTypes"
                            value="Seeker"
                            class="nl-option__input"
                          />
                          <span class="nl-option__box"><i class="fa fa-check"></i></span>
                          <span class="nl-option__text">
                            <span class="nl-option__title">Cultural Explorer</span>
                            <span class="nl-option__desc">Interested in exploring culture, events, and organizations.</span>
                          </span>
                        </label>
                        <label
                          class="nl-option"
                          :class="{ 'nl-option--selected': formFields.userTypes.includes('Organization') }"
                        >
                          <input
                            type="checkbox"
                            name="userType"
                            v-model="formFields.userTypes"
                            value="Organization"
                            class="nl-option__input"
                          />
                          <span class="nl-option__box"><i class="fa fa-check"></i></span>
                          <span class="nl-option__text">
                            <span class="nl-option__title">Organizer/Business</span>
                            <span class="nl-option__desc">Interested in sharing your organization, events, and culture.</span>
                          </span>
                        </label>
                      </div>
                      <p v-if="userTypesError" class="nl-error mt-2">{{ userTypesError }}</p>
                    </span>
                  </span>
                  <span class="g-input-btn mt-3">
                    <primary-loader :is-loading="isSubmitting" />
                    <button v-if="!isSubmitting" type="submit" class="f-g-btn">SUBMIT</button>
                  </span>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot />
  </custom-modal>

  <thank-you-news-letter-modal
    :modal-active="isOpenThankYouNewsLetterModal"
    :user-type="userType"
    :toggle-modal="openThankYouNewsLetterModal"
  />
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import CustomModal from "@/components/common/modal/custom-modal";
import logoIcon from "@/assets/logo-icon.png";
import BaseInput from "@/components/common/form/base-input";
import ApiClient from "@/methods/apiclient";
import ThankYouNewsLetterModal from "@/components/presentational/news-letter/modals/thank-you-news-letter-modal";
import PrimaryLoader from "@/components/common/loaders/primary-loader";

const emit = defineEmits([]);

const props = defineProps({
  modalActive: {
    type: Boolean,
    required: true,
  },
  toggleModal: {
    type: Function,
    required: true,
  },
});

const formFields = reactive({
  email: "",
  userTypes: [],
});

const userType = ref("");

const isEmail = (email) => {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
};

const isOpenThankYouNewsLetterModal = ref(false);
const openThankYouNewsLetterModal = () => {
  window.scrollTo(0, 0);
  isOpenThankYouNewsLetterModal.value = !isOpenThankYouNewsLetterModal.value;
  document.getElementById("body").classList.add("modalOpened");
};

const emailErrorMessage = ref("");
const userTypesError = ref("");
const errorMessage = ref("");
const isSubmitting = ref(false);

watch(() => formFields.userTypes.length, () => {
  if (formFields.userTypes.length > 0) userTypesError.value = "";
});

const submitNewsLetterForm = () => {
  emailErrorMessage.value = "";
  userTypesError.value = "";

  if (formFields.email === "") {
    emailErrorMessage.value = "Email address is required";
    return false;
  } else if (!isEmail(formFields.email)) {
    emailErrorMessage.value = "Please enter a valid email address";
    return false;
  }

  if (formFields.userTypes.length === 0) {
    userTypesError.value = "Please select at least one focus area";
    return false;
  }

  const params = {
    email: formFields.email,
    userType: formFields.userTypes.join(", "),
  };

  isSubmitting.value = true;

  ApiClient.post("newsletter", params).then((res) => {
    if (res.status) {
      userType.value = formFields.userTypes.join(" & ");

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'newsletter_subscribe', {
          user_type: formFields.userTypes.join(', '),
        });
      }

      emit("handle-close-modal");

      formFields.email = "";
      formFields.userTypes = [];

      openThankYouNewsLetterModal();
    } else {
      errorMessage.value = res.message;
    }
  }).finally(() => {
    isSubmitting.value = false;
  });
};
</script>

<style scoped>
.nl-error {
  font-size: 12px;
  color: #dc3545;
  margin: 4px 0 0;
}

.nl-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nl-option {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.nl-option:hover {
  border-color: #f05537;
  box-shadow: 0 2px 10px rgba(240, 85, 55, 0.08);
}

.nl-option--selected {
  border-color: #f05537;
  background: #fff8f7;
}

.nl-option__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.nl-option__box {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  transition: all 0.2s ease;
}

.nl-option__box i {
  font-size: 10px;
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.nl-option--selected .nl-option__box {
  background: #f05537;
  border-color: #f05537;
}

.nl-option--selected .nl-option__box i {
  opacity: 1;
}

.nl-option__text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.nl-option__title {
  font-size: 14px;
  font-weight: 700;
  color: #14163c;
  line-height: 1.3;
}

.nl-option__desc {
  font-size: 12px;
  color: #6b6b6b;
  line-height: 1.5;
}
</style>
